import buttonLoader from '../utilities/buttonLoader.js';

const button = {
  init: function() {
    this.loader();
  },

  loader: function () {


    var buttons = document.getElementsByClassName('button--loader');

    Array.prototype.forEach.call(buttons, (button, index) => {

      button.addEventListener('click', (e) => {

        buttonLoader.start(button);

      })
    });
  }
}

button.initialize = () => {
  button.init();
};

module.exports = button;
